<script lang="ts">
  import MatchList from '../components/match/MatchList.svelte';
  import { refreshSettings, settingsStore } from '../stores/settings';
  import { onMount } from 'svelte';
  import { trackEvent } from '../lib/apiService';
  export let params: { target?: string } = {};
  
  // Extract target from URL parameters, default to 'report'
  $: target = params?.target;
  $: scope = target === 'report' ? 'past' : 'future';

  onMount(async () => {
    // Ensure settings are loaded before rendering the modal
    if (!$settingsStore.active_team.id) {
      await refreshSettings();
    }
  });
</script>

{#if target && scope}
  <MatchList {target} {scope} />
{/if}